import React from "react";
import { IoLogoWhatsapp } from "react-icons/io";

const WhatsApp = () => {
    const phoneNumber = "8860733786"; // Replace with your WhatsApp number
    const message = encodeURIComponent("Hello!");

    return (
        <a
            href={`https://wa.me/${phoneNumber}?text=${message}`}
            target="_blank"
            rel="noopener noreferrer"
            className="whatsapp-button"
        >
            <IoLogoWhatsapp className="whatsapp-icon" />
        </a>
    );
};

export default WhatsApp;